if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

var lastScrollTop = 0;

(function(){

    /*
        HOME ARROW
        $('.arrow-home').click(function(event) {
            $('body, html').animate({
                scrollTop: $(window).height()-$('header').outerHeight()*2},
                800, 'easeOutExpo');
        });
    */

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });

    //HOMEPAGE HERO SLIDER
    $('.hero__uvp-scroll').slick({
        accessibility: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 0,
        cssEase: 'linear',
        dots: false,
        infinite: true,
        pauseOnHover: false, 
        speed: 6000,
        variableWidth: true
    });

    $('.hero__image-scroll, .hero__slider').slick({
        accessibility: true,
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: false,
        fade: true, 
        pauseOnHover: false, 
        speed: 700
    });

    // FANCYBOXES
    $('.fancybox').fancybox({
        toolbar: false,
        smallBtn: true,
        infobar: false,
        loop: true
    });

    $('.fancybox-module').fancybox({
        baseClass: 'fancybox-popup__wrapper',
        arrows: false 
    });

    window.onload = function() {
		/*this function add a class to header when scroll down the page
		/* and change the logo by a new file if needed depending of mockup
		*/

		// scrollDownAction(20, 'scroll');

		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})

        // Open lightbox to leave a review
        setTimeout(() => {
            if (window.location.href.indexOf("leave-a-review") > -1) {
                document.getElementById("leave-a-review").click();
            }
        }, 1000);

        document.querySelectorAll(`a:not([href^="#"]), button:not([href^="#"])`).forEach( a => { if( a.textContent.toLowerCase().trim() == 'book now' || a.textContent.toLowerCase().trim() == 'check availability' ){ a.innerHTML += `<script async src='https://tag.simpli.fi/sifitag/9f2b7812-e38a-4a1f-98c7-97a131866ae9'></script>`; } } );
	};

    function scrollW() {
        let st = window.pageYOffset || document.documentElement.scrollTop;
        if (st > 0) {
            if (st > lastScrollTop) {
                // downscroll code
                if (!document.getElementById('header').classList.contains('down')) {
                    document.getElementById('header').classList.add('down');
                    document.getElementById('header').classList.remove('up');
                }
            } else {
                // upscroll code
                if (!document.getElementById('header').classList.contains('up')) {
                    document.getElementById('header').classList.add('up');
                    document.getElementById('header').classList.remove('down');
                }
            }
        } else {
            if (document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')) {
                document.getElementById('header').classList.remove('up');
                document.getElementById('header').classList.remove('down');
            }
        }
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
    }

})();